import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import CompactDialog from '../../../components/dialogs/CompactDialog';
import WarningIcon from '../../../assets/icons/banco-de-chile/WarningIcon';
import { WARNING_ICON_STACK_CLASS_NAME } from '../../../theme/constants/stack';

const CannotAcceptTyCDialog = ({ open, onRetry, onClose, description }) => (
  <CompactDialog
    open={open}
    onClose={onClose}
    title={(
      <Typography variant="medium_2" color="warning.A700" fontWeight={400}>
        Presentamos intermitencias en el servicio
      </Typography>
    )}
    topIcon={WarningIcon}
    topIconProps={{
      svgWrapperClassName: WARNING_ICON_STACK_CLASS_NAME,
      sx: { width: 60, height: 60 },
    }}
    titleBackgroundColor="white"
    hideCloseButton
    maxWidth={680}
    spacing={2}
    contentPadding={{ py: 3, px: 2 }}
  >
    <Stack spacing={2} alignItems="center">
      <Typography
        variant="small_2"
        color="gray.A500"
        align="center"
      >
        {description}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={onRetry}
      >
        <Typography variant="small_2" fontWeight={700}>
          Reintentar
        </Typography>
      </Button>
    </Stack>
  </CompactDialog>
);

CannotAcceptTyCDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onRetry: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
};

export default CannotAcceptTyCDialog;
